module.exports = __webpack_public_path__ + "static/img/RAWP-1_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAWP-1_1.png
// module id = UzuK
// module chunks = 0